import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { clsWaitTimeMs } from '../constants';
import { logger } from '../logger';
import { isPageLoadMetricData, isPageSegmentLoadMetricData } from '../metric/types';
import { appFramework } from '../plugins/app/framework';
import { appVersion } from '../plugins/app/version';
import { bmVersion } from '../plugins/bm/version';
import { customData } from '../plugins/custom';
import { eventId } from '../plugins/event/id';
import { eventInitial } from '../plugins/event/initial';
import { eventKey } from '../plugins/event/key';
import { eventLocalTime } from '../plugins/event/local-time';
import { eventProduct } from '../plugins/event/product';
import { eventRegion } from '../plugins/event/region';
import { eventRoute } from '../plugins/event/route';
import { eventType } from '../plugins/event/type';
import { featureFlags } from '../plugins/feature-flags';
import { hostname } from '../plugins/hostname';
import { customEventMetrics } from '../plugins/metrics/custom-event-metrics';
import { initialPageLoadMetrics } from '../plugins/metrics/initial-page-load-metrics';
import { interactionMetrics } from '../plugins/metrics/interaction-metrics';
import { navigationMetrics } from '../plugins/metrics/navigation-metrics';
import { pageLoadMetrics } from '../plugins/metrics/page-load-metrics';
import { pageSegmentLoadMetrics } from '../plugins/metrics/page-segment-load-metrics';
import { webVitalsMetrics } from '../plugins/metrics/web-vitals-metrics';
import { pageVisibleState } from '../plugins/page-visible/state';
import { pageVisibleValue } from '../plugins/page-visible/value';
import { productCustomData } from '../plugins/product/custom';
import { ssrFeatureFlags } from '../plugins/ssr/feature-flags';
import { ssrSuccess } from '../plugins/ssr/success';
import { telemetryBrowser } from '../plugins/telemetry/browser';
import { telemetryCpu } from '../plugins/telemetry/cpus';
import { telemetryMemory } from '../plugins/telemetry/memory';
import { telemetryNetwork } from '../plugins/telemetry/network';
import { appTimings } from '../plugins/timings/app';
import { bundleEvalTimings } from '../plugins/timings/bundle-eval';
import { resourceTimings } from '../plugins/timings/resource';
import { BMEventsType } from '../types';
var defaultSet = [eventKey, eventType, eventProduct, eventRoute, eventId, eventLocalTime, eventRegion, appFramework, appVersion, bmVersion, telemetryBrowser, telemetryCpu, telemetryMemory, telemetryNetwork, customData, featureFlags, hostname, productCustomData, appTimings, resourceTimings];
var pageLoadCommon = [].concat(defaultSet, [pageVisibleState, pageVisibleValue, eventInitial, pageLoadMetrics, bundleEvalTimings]);
var initialPageLoadSet = [].concat(_toConsumableArray(pageLoadCommon), [initialPageLoadMetrics, navigationMetrics, ssrSuccess, ssrFeatureFlags]);
var spaTransitionSet = _toConsumableArray(pageLoadCommon);
var pageSegmentLoadSet = [].concat(defaultSet, [pageSegmentLoadMetrics, pageVisibleState, pageVisibleValue, eventInitial, bundleEvalTimings]);
var interactionSet = [].concat(defaultSet, [pageVisibleState, pageVisibleValue, interactionMetrics]);
var customMetricSet = [].concat(defaultSet, [pageVisibleState, pageVisibleValue, customEventMetrics]);
// pageVisibleState and pageVisibleValue has been handled within webVitalsMetrics.
var webVitalsMetricSet = [].concat(defaultSet, [webVitalsMetrics]);

// Function that returns a promise which resolves after clsWaitTimeMs + 500ms
// so that clsData is guaranteed to be attached to window
var waitForCLS = function waitForCLS() {
  var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : clsWaitTimeMs + 500;
  return new Promise(function (resolve) {
    return setTimeout(resolve, delay);
  });
};
export var eventDataProcessor = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(globalConfig, data) {
    var set, plugins, _iterator, _step, plugin, result, pluginResults, generated;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(data.start === null || data.stop === null)) {
            _context.next = 3;
            break;
          }
          logger.log("eventDataProcessor: Metric \"".concat(data.key, "\" start or stop are incorrect; start: ").concat(data.start, "; stop: ").concat(data.stop));
          return _context.abrupt("return", null);
        case 3:
          set = [];
          if (data.config.type === BMEventsType.PAGE_LOAD && isPageLoadMetricData(data) && data.isInitial) {
            set = initialPageLoadSet;
          }
          if (data.config.type === BMEventsType.PAGE_LOAD && isPageLoadMetricData(data) && !data.isInitial) {
            set = spaTransitionSet;
          }
          if (data.config.type === BMEventsType.PAGE_SEGMENT_LOAD && isPageSegmentLoadMetricData(data)) {
            set = pageSegmentLoadSet;
          }
          if (data.config.type === BMEventsType.INLINE_RESULT) {
            set = interactionSet;
          }
          if (data.config.type === BMEventsType.CUSTOM) {
            set = customMetricSet;
          }
          if (!(data.config.type === BMEventsType.WEB_VITALS)) {
            _context.next = 13;
            break;
          }
          set = webVitalsMetricSet;

          // Wait for CLS to be recorded before proceeding to run plugin and attach CLS data
          _context.next = 13;
          return waitForCLS();
        case 13:
          //TODO if type is different - do not send at all
          plugins = [];
          _iterator = _createForOfIteratorHelper(set);
          _context.prev = 15;
          _iterator.s();
        case 17:
          if ((_step = _iterator.n()).done) {
            _context.next = 25;
            break;
          }
          plugin = _step.value;
          _context.next = 21;
          return plugin(data.config, data,
          // some plugins support page load specific data with special check
          globalConfig);
        case 21:
          result = _context.sent;
          if (result) {
            plugins.push(result);
          }
        case 23:
          _context.next = 17;
          break;
        case 25:
          _context.next = 30;
          break;
        case 27:
          _context.prev = 27;
          _context.t0 = _context["catch"](15);
          _iterator.e(_context.t0);
        case 30:
          _context.prev = 30;
          _iterator.f();
          return _context.finish(30);
        case 33:
          _context.next = 35;
          return Promise.all(plugins);
        case 35:
          pluginResults = _context.sent;
          generated = {};
          pluginResults.forEach(function (pluginResult) {
            if (pluginResult === null) {
              return;
            }
            Object.keys(pluginResult).forEach(function (key) {
              var keyResult = pluginResult[key];
              if (keyResult !== null && keyResult !== undefined) {
                generated[key] = keyResult;
              }
            });
          });
          return _context.abrupt("return", generated);
        case 39:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[15, 27, 30, 33]]);
  }));
  return function eventDataProcessor(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();